import React, { useEffect, useRef, useState } from "react";
import { history } from "../../../core/helpers/history";
import { router } from "../../../core/helpers/router";
import "./PaymentIframe.scss";

interface PaymentIframeProps {
  htmlContent: string;
  onClose: () => void;
}

const PaymentIframe: React.FC<PaymentIframeProps> = ({
  htmlContent,
  onClose,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    // Write HTML content to iframe when available
    if (iframeRef.current && htmlContent) {
      try {
        setIframeLoaded(false);

        // Add event listener for postMessage
        const handleMessage = (event: MessageEvent) => {
          console.log("Received message from iframe:", event.data);

          // Check if the message is related to payment
          if (event.data === "payment-success") {
            console.log("Payment successful, navigating to success page");
            history.push(router.PAY_BY_ME_SUCCESS);
          } else if (event.data === "payment-failed") {
            console.log("Payment failed, navigating to failed page");
            history.push(router.PAY_BY_ME_FAILED);
          }
        };

        // Add the event listener
        window.addEventListener("message", handleMessage);

        // Cleanup function to remove event listener
        return () => {
          window.removeEventListener("message", handleMessage);
        };
      } catch (error) {
        console.error("Error setting up iframe:", error);
      }
    }
  }, [htmlContent]);

  const handleIframeLoad = () => {
    console.log("Iframe loaded successfully");
    setIframeLoaded(true);
  };

  return (
    <div className="payment-iframe-container">
      <div className="payment-iframe-content">
        <iframe
          ref={iframeRef}
          srcDoc={htmlContent}
          title="Payment Form"
          className={`payment-iframe ${iframeLoaded ? "loaded" : "loading"}`}
          sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-modals"
          onLoad={handleIframeLoad}
        />
      </div>
    </div>
  );
};

export default PaymentIframe;
